module.exports = __webpack_public_path__ + "static/img/img.58fa7de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img.png
// module id = UBpp
// module chunks = 1